const SET_USERS = 'SET_USERS'
const CHANGE_LOADING = 'CHANGE_LOADING'
const SET_RANGE_DATE = 'SET_RANGE_DATE'
const SET_DATA_USERS = 'SET_DATA_USERS'
const CHANGE_ADMIN = 'CHANGE_ADMIN'
const SET_USER_ID = 'SET_USER_ID'

const initialState = {
    users: [],
    loading: false,
    range_date: [],
    data_about_users: [],
    admin: false,
    user_id: null
}

export const main_reducer = (state = initialState, action) => {
    switch (action.type) {

        case SET_DATA_USERS:
            return {...state, data_about_users: action.payload}

        case SET_RANGE_DATE:
            return {...state, range_date: action.payload}

        case CHANGE_LOADING:
            return {...state, loading: action.payload}

        case SET_USERS: {
            return {...state, users: action.payload}
        }

        case SET_USER_ID:
            return {...state, user_id: action.payload}

        case CHANGE_ADMIN :
            return {...state, admin: action.payload}

        default :
            return state
    }
}

export const set_users = (users) => ({type: SET_USERS, payload: users})
export const change_loading = (bool) => ({type: CHANGE_LOADING, payload: bool})
export const set_data_users = (data) => ({type: SET_DATA_USERS, payload: data})
export const set_range_date = (dates) => ({type: SET_RANGE_DATE, payload: dates})
export const change_admin = (bool) => ({type: CHANGE_ADMIN, payload: bool})
export const set_user_id = (user_id) => ({type: SET_USER_ID, payload: user_id})